import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaSearch, FaFilter, FaSort, FaEdit, FaTrash } from 'react-icons/fa';

const AdminRestaurants = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [sortField, setSortField] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const token = localStorage.getItem('adminToken');

  // const [prevPage, setPrevPage] = useState(1);
  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        // if (searchQuery) {
        //   setPrevPage(currentPage);
        //   console.log(currentPage);

        //   setCurrentPage(1);
        // } else {
        //   if (prevPage !== 1) {
        //     setCurrentPage(prevPage);
        //   }
        // }
        const response = await axios.get('/api/admin/restaurants', {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            search: searchQuery,
            status: filterStatus,
            sortField,
            sortOrder,
            page: currentPage,
          },
        });
        setRestaurants(response.data.restaurants);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error('Error fetching restaurants:', error);
      }
    };

    fetchRestaurants();
  }, [searchQuery, filterStatus, sortField, sortOrder, currentPage, token]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const handleDelete = async (restaurantId) => {
    // Show confirmation dialog
    if (window.confirm('Are you sure you want to delete this restaurant?')) {
      try {
        await axios.delete(`/api/admin/restaurants/${restaurantId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRestaurants(restaurants.filter((r) => r._id !== restaurantId));
      } catch (error) {
        console.error('Error deleting restaurant:', error);
      }
    }
  };

  return (
    <div>
      <h1 className='text-3xl font-bold mb-8'>Restaurants</h1>
      <div className='flex space-x-4 mb-6'>
        <div className='relative w-full'>
          <input
            type='text'
            className='w-full p-3 border rounded'
            placeholder='Search Restaurants'
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <FaSearch className='absolute top-3 right-4 text-gray-500' />
        </div>
        <div className='relative w-full'>
          <select
            className='w-full p-3 border rounded'
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value=''>Filter by Status</option>
            <option value='active'>Active</option>
            <option value='inactive'>Inactive</option>
          </select>
          <FaFilter className='absolute top-3 right-4 text-gray-500' />
        </div>
      </div>

      <div className='overflow-x-auto'>
        <table className='w-full table-auto bg-white shadow-lg rounded'>
          <thead>
            <tr className='text-left'>
              <th
                className='p-4 cursor-pointer'
                onClick={() => handleSort('name')}
              >
                Name <FaSort />
              </th>
              <th
                className='p-4 cursor-pointer'
                onClick={() => handleSort('address')}
              >
                Address <FaSort />
              </th>
              <th className='p-4'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {restaurants?.map((restaurant) => (
              <tr key={restaurant._id} className='border-t'>
                <td className='p-4'>{restaurant.name}</td>
                <td className='p-4'>{restaurant.address}</td>
                <td className='p-4 flex space-x-2'>
                  <Link
                    to={`/admin/restaurants/${restaurant._id}/edit`}
                    className='bg-blue-500 text-white py-1 px-3 rounded'
                  >
                    <FaEdit />
                  </Link>
                  <button
                    onClick={() => handleDelete(restaurant._id)}
                    className='bg-red-500 text-white py-1 px-3 rounded'
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className='flex justify-between mt-6'>
        <button
          className='bg-gray-500 text-white py-2 px-4 rounded'
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span className='text-lg'>
          Page {currentPage} of {totalPages}
        </span>
        <button
          className='bg-gray-500 text-white py-2 px-4 rounded'
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AdminRestaurants;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { FaSearch, FaFilter } from 'react-icons/fa';

// const AdminRestaurants = () => {
//   const [restaurants, setRestaurants] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [filterQuery, setFilterQuery] = useState('');
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchRestaurants = async () => {
//       try {
//         const response = await axios.get('/api/admin/restaurants', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setRestaurants(response.data);
//       } catch (error) {
//         console.error('Error fetching restaurants:', error);
//       }
//     };

//     fetchRestaurants();
//   }, [token]);

//   const filteredRestaurants = restaurants.filter((restaurant) =>
//     restaurant.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Restaurants</h1>
//       <div className='flex space-x-4 mb-6'>
//         <div className='relative w-full'>
//           <input
//             type='text'
//             className='w-full p-3 border rounded'
//             placeholder='Search Restaurants'
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//           <FaSearch className='absolute top-3 right-4 text-gray-500' />
//         </div>
//         <div className='relative w-full'>
//           <select
//             className='w-full p-3 border rounded'
//             value={filterQuery}
//             onChange={(e) => setFilterQuery(e.target.value)}
//           >
//             <option value=''>Filter by</option>
//             <option value='active'>Active</option>
//             <option value='inactive'>Inactive</option>
//           </select>
//           <FaFilter className='absolute top-3 right-4 text-gray-500' />
//         </div>
//       </div>
//       <div className='space-y-4'>
//         {filteredRestaurants.map((restaurant) => (
//           <div
//             key={restaurant._id}
//             className='bg-white p-4 rounded shadow flex justify-between items-center'
//           >
//             <div>
//               <h2 className='text-xl font-semibold'>{restaurant.name}</h2>
//               <p className='text-gray-500'>{restaurant.address}</p>
//             </div>
//             <Link
//               to={`/admin/restaurants/${restaurant._id}/edit`}
//               className='bg-blue-500 text-white py-2 px-4 rounded'
//             >
//               Edit
//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AdminRestaurants;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { FaPlus, FaEdit, FaTrash, FaSync } from 'react-icons/fa';
// import Pagination from '../Common/Pagination';

// const AdminRestaurants = () => {
//   const [restaurants, setRestaurants] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(1);
//   const [pages, setPages] = useState(1);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchRestaurants = async () => {
//       try {
//         const response = await axios.get(
//           `/api/admin/restaurants?pageNumber=${page}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setRestaurants(response.data.restaurants);
//         setPages(response.data.pages);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching restaurants:', error);
//         setLoading(false);
//       }
//     };

//     fetchRestaurants();
//   }, [page, token]);

//   const deleteRestaurant = async (id) => {
//     if (window.confirm('Are you sure you want to delete this restaurant?')) {
//       try {
//         await axios.delete(`/api/admin/restaurants/${id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setRestaurants(
//           restaurants.filter((restaurant) => restaurant._id !== id)
//         );
//       } catch (error) {
//         console.error('Error deleting restaurant:', error);
//       }
//     }
//   };

//   const regenerateQRCode = async (id) => {
//     if (window.confirm('Are you sure you want to regenerate the QR Code?')) {
//       try {
//         await axios.put(
//           `/api/admin/restaurants/${id}/regenerate-qr`,
//           {},
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         alert('QR Code regenerated successfully.');
//         // Optionally, refetch the data to update the QR code in the UI
//       } catch (error) {
//         console.error('Error regenerating QR Code:', error);
//       }
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Manage Restaurants</h1>
//       <Link
//         to='/admin/restaurants/create'
//         className='inline-block bg-blue-500 text-white py-2 px-4 rounded mb-8'
//       >
//         <FaPlus className='mr-2 inline' /> Add Restaurant
//       </Link>
//       <table className='w-full text-left'>
//         <thead>
//           <tr>
//             <th className='p-4 border-b'>Name</th>
//             <th className='p-4 border-b'>Owner</th>
//             <th className='p-4 border-b'>Membership</th>
//             <th className='p-4 border-b'>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {restaurants?.map((restaurant) => (
//             <tr key={restaurant._id}>
//               <td className='p-4 border-b'>{restaurant.name}</td>
//               <td className='p-4 border-b'>{restaurant.owner.name}</td>
//               <td className='p-4 border-b capitalize'>
//                 {restaurant.membership.type}
//               </td>
//               <td className='p-4 border-b flex'>
//                 <Link
//                   to={`/admin/restaurants/${restaurant._id}/edit`}
//                   className='mr-4 text-blue-500'
//                 >
//                   <FaEdit />
//                 </Link>
//                 <button
//                   onClick={() => deleteRestaurant(restaurant._id)}
//                   className='mr-4 text-red-500'
//                 >
//                   <FaTrash />
//                 </button>
//                 <button
//                   onClick={() => regenerateQRCode(restaurant._id)}
//                   className='text-green-500'
//                 >
//                   <FaSync />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <Pagination
//         page={page}
//         pages={pages}
//         onChangePage={(newPage) => setPage(newPage)}
//       />
//     </div>
//   );
// };

// export default AdminRestaurants;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { FaRegEdit, FaTrashAlt, FaPlus } from 'react-icons/fa';

// const AdminRestaurants = () => {
//   const [restaurants, setRestaurants] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchRestaurants = async () => {
//       try {
//         const response = await axios.get('/api/admin/restaurants', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setRestaurants(response.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching restaurants:', error);
//         setLoading(false);
//       }
//     };

//     fetchRestaurants();
//   }, [token]);

//   const handleDelete = async (restaurantId) => {
//     try {
//       await axios.delete(`/api/admin/restaurants/${restaurantId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setRestaurants(
//         restaurants.filter((restaurant) => restaurant._id !== restaurantId)
//       );
//     } catch (error) {
//       console.error('Error deleting restaurant:', error);
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <h1 className='text-3xl font-bold mb-6'>Manage Restaurants</h1>

//       <div className='mb-4'>
//         <button className='bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded flex items-center'>
//           <FaPlus className='mr-2' /> Add New Restaurant
//         </button>
//       </div>

//       <ul>
//         {restaurants.map((restaurant) => (
//           <li
//             key={restaurant._id}
//             className='mb-4 p-4 bg-gray-100 rounded shadow-sm flex justify-between items-center'
//           >
//             <div>
//               <h2 className='text-xl font-semibold'>{restaurant.name}</h2>
//               <p>Owner: {restaurant.owner.email}</p>
//             </div>
//             <div className='flex items-center'>
//               <button className='bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mr-2 flex items-center'>
//                 <FaRegEdit className='mr-2' /> Edit
//               </button>
//               <button
//                 onClick={() => handleDelete(restaurant._id)}
//                 className='bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded flex items-center'
//               >
//                 <FaTrashAlt className='mr-2' /> Delete
//               </button>
//             </div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default AdminRestaurants;
